import React, { useEffect, useState } from 'react';
import "./Cart.css";
import { useAuth } from '../../Context/Authcontext';
import Tablecard from '../../Components/Tablecard/Tablecard';
import { Link, useNavigate } from 'react-router-dom';

function Cart() {

    const navigate = useNavigate();
    const { userdata, isloggedin, login } = useAuth();

    const [selectedState, setSelectedState] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isDirty, setIsDirty] = useState(false);
    const [optionpop, setOptionpop] = useState('none');
    const [couponInput, setCouponInput] = useState('');
    const [couponData, setCouponData] = useState(null);
    const [couponError, setCouponError] = useState('');
    const [couponLoading, setCouponLoading] = useState(false);
    const [address, setAddress] = useState({
        city: "",
        state: "",
        country: "India",
        address: "",
        pincode: "",
    })

    const allcities = [
        {
            state: "All India",
            cities: ["All India"]
        },
        {
            state: "Andhra Pradesh",
            cities: ["Adoni", "Amalapuram", "Anantapur", "Atmakur", "Bhimavaram", "Bobbili", "Bapatla", "Chittoor", "Chilakaluripet", "Dharmavaram", "Darsi", "Dowleswaram", "Eluru", "Giddalur", "Gokavaram", "Gooty", "Gudivada", "Gudur", "Guntakal", "Guntur", "Hindupur", "Jaggayyapeta", "Kadapa", "Kakinada", "Kalyandurg", "Kandukur", "Kavali", "Kothapeta", "Kurnool", "Lepakshi", "Machilipatnam", "Madanapalle", "Macherla", "Mandapeta", "Mangalagiri", "Markapur", "Mydukuru", "Nagari", "Nandyal", "Narasaraopet", "Narsipatnam", "Nellore", "Nidadavole", "Nuzvid", "Ongole", "Palakollu", "Peddapuram", "Pithapuram", "Ponnur", "Proddatur", "Pulivendula", "Punganur", "Puttur", "Rajahmundry", "Rayachoti", "Rayadurg", "Repalle", "Salur", "Samalkot", "Sattenapalle", "Srikakulam", "Sullurupeta", "Suryaraopeta", "Tadipatri", "Tadepalligudem", "Tenali", "Tirupati", "Vinukonda", "Vijayawada", "Visakhapatnam", "Vizianagaram", "Yemmiganur"]
        },
        {
            state: "Arunachal Pradesh",
            cities: ["Along", "Anini", "Basar", "Bomdila", "Bhalukpong", "Changlang", "Daporijo", "Dirang", "Itanagar", "Jairampur", "Khonsa", "Koloriang", "Likabali", "Longding", "Namsai", "Pasighat", "Palin", "Roing", "Seppa", "Tawang", "Tezu", "Tirap", "Tuting", "Yingkiong", "Ziro"]
        },
        {
            state: "Assam",
            cities: ["Abhayapuri", "Amguri", "Azara", "Badarpur", "Barpeta", "Barpeta Road", "Bongaigaon", "Bokakhat", "Bokajan", "Bokolia", "Biswanath Chariali", "Charaideo", "Changsari", "Charaibari", "Chirang", "Chhaparmukh", "Dhekiajuli", "Dhubri", "Dibrugarh", "Diphu", "Duliajan", "Dergaon", "Doomdooma", "Goalpara", "Golaghat", "Gohpur", "Guwahati", "Gauripur", "Haflong", "Hailakandi", "Hajo", "Hatsingimari", "Hojai", "Howly", "Jagiroad", "Jorhat", "Jonai", "Kampur", "Karimganj", "Kokrajhar", "Lakhipur", "Lakhimpur", "Majuli", "Mangaldoi", "Margherita", "Mariani", "Moranhat", "Morigaon", "Nalbari", "Namrup", "Narayanpur", "Nazira", "Nagaon", "North Lakhimpur", "Pathsala", "Palasbari", "Rangia", "Sadiya", "Sibsagar", "Silchar", "Sonari", "Sorbhog", "Tinsukia", "Tezpur", "Titabar", "Tamulpur", "Udalguri", "West Karbi Anglong"]
        },
        {
            state: "Bihar",
            cities: ["Araria", "Arrah", "Aurangabad", "Bagaha", "Barauli", "Barh", "Begusarai", "Bhabua", "Bhagalpur", "Bihar Sharif", "Bikramganj", "Buxar", "Chhapra", "Darbhanga", "Daudnagar", "Dehri-on-Sone", "Dumraon", "Gaya", "Gopalganj", "Hajipur", "Hilsa", "Jamalpur", "Jamui", "Jehanabad", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhubani", "Mahnar Bazar", "Mairwa", "Maner", "Masaurhi", "Munger", "Motihari", "Motipur", "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Phulwari Sharif", "Purnia", "Rajgir", "Raxaul", "Revilganj", "Rosera", "Saharsa", "Samastipur", "Sasaram", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Sonepur", "Supaul", "Udakishanganj", "Vaishali", "Warsaliganj"]
        },
        {
            state: "Chhattisgarh",
            cities: ["Ambikapur", "Akaltara", "Arang", "Baikunthpur", "Balod", "Baloda Bazar", "Balrampur", "Bemetara", "Bhanupratappur", "Bhilai", "Bijapur", "Bilaspur", "Birgaon", "Champa", "Chirmiri", "Charama", "Dalli-Rajhara", "Dantewada", "Dhamtari", "Durg", "Gaurella", "Gariaband", "Jagdalpur", "Janjgir", "Jashpur", "Jashpurnagar", "Kanker", "Kawardha", "Khairagarh", "Korba", "Kondagaon", "Koriya", "Mahasamund", "Manendragarh", "Mungeli", "Narayanpur", "Pandariya", "Pathalgaon", "Patan", "Pendra", "Phundhar", "Raigarh", "Raipur", "Rajnandgaon", "Ratanpur", "Sakti", "Saraipali", "Sarangarh", "Sukma", "Surajpur", "Takhatpur", "Tilda", "Umarkote"]
        },
        {
            state: "Delhi",
            cities: ["Alaknanda", "Anand Vihar", "Ashok Vihar", "Chanakyapuri", "Chhatarpur", "Connaught Place", "Defence Colony", "Dwarka", "East of Kailash", "Greater Kailash", "Green Park", "Hauz Khas", "Janakpuri", "Jangpura", "Kalkaji", "Karol Bagh", "Lajpat Nagar", "Malviya Nagar", "Mayur Vihar", "Model Town", "Munirka", "Narela", "New Friends Colony", "Okhla", "Paharganj", "Patel Nagar", "Pitampura", "Punjabi Bagh", "Rajouri Garden", "Rohini", "Saket", "Sarita Vihar", "Sarojini Nagar", "Shahdara", "South Extension", "Tilak Nagar", "Uttam Nagar", "Vasant Kunj", "Vasant Vihar", "Vikaspuri", "Yamuna Vihar"]
        },
        {
            state: "Goa",
            cities: ["Arambol", "Assagao", "Baga", "Bicholim", "Canacona", "Cansaulim", "Candolim", "Carambolim", "Chicalim", "Colva", "Cuncolim", "Curca", "Dharbandora", "Dabolim", "Dona Paula", "Mapusa", "Margao", "Mormugao", "Mollem", "Navelim", "Nuvem", "Panaji", "Pernem", "Ponda", "Porvorim", "Saligao", "Sanquelim", "Siolim", "Sanguem", "Seraulim", "Tivim", "Taleigao", "Valpoi", "Vasco da Gama", "Verna", "Vagator"]
        },
        {
            state: "Gujarat",
            cities: ["Ahmedabad", "Amreli", "Anand", "Anjar", "Ankleshwar", "Bardoli", "Bayad", "Bhachau", "Bhadran", "Bhavnagar", "Bhuj", "Botad", "Chhota Udaipur", "Chorvad", "Dahod", "Deesa", "Dhandhuka", "Dholka", "Dhoraji", "Dwarka", "Gandhidham", "Gandhinagar", "Godhra", "Gondal", "Halol", "Himatnagar", "Jamnagar", "Jetpur", "Junagadh", "Kalol", "Kapadvanj", "Karjan", "Keshod", "Khambhat", "Kheda", "Khedbrahma", "Lathi", "Lunawada", "Mahesana", "Mandvi", "Manavadar", "Mansa", "Modasa", "Morbi", "Muli", "Nadiad", "Navsari", "Palanpur", "Palitana", "Patan", "Porbandar", "Rajkot", "Rajpipla", "Rajula", "Sachin", "Salaya", "Sanand", "Savarkundla", "Siddhpur", "Sihor", "Songadh", "Surat", "Talaja", "Thangadh", "Tharad", "Umbergaon", "Unjha", "Vadodara", "Valsad", "Vapi", "Veraval", "Vijapur", "Viramgam", "Visnagar", "Wadhwan"]
        },
        {
            state: "Haryana",
            cities: ["Ambala", "Bahadurgarh", "Ballabgarh", "Bhiwani", "Barwala", "Charkhi Dadri", "Chandigarh", "Faridabad", "Fatehabad", "Gurgaon", "Gohana", "Hisar", "Hansi", "Hodal", "Jagadhri", "Jind", "Jhajjar", "Karnal", "Kaithal", "Kherki Daula", "Mahendragarh", "Mewat", "Meham", "Mohindergarh", "Narnaul", "Palwal", "Panipat", "Pataudi", "Rohtak", "Rewari", "Sirsa", "Sohna", "Sadulshahar", "Tohana", "Yamunanagar"]
        },
        {
            state: "Himachal Pradesh",
            cities: ["Arki", "Aru", "Anni", "Baddi", "Bilaspur", "Baijnath", "Banjar", "Bhuntar", "Bharari", "Bharmaur", "Chamba", "Chirgaon", "Chaupal", "Dharamshala", "Dalhousie", "Dehra", "Dhameta", "Dharampur", "Ghumarwin", "Gagret", "Gopalpur", "Hamirpur", "Hatu", "Jubbal", "Kangra", "Kullu", "Keylong", "Koti", "Kothi", "Mcleod Ganj", "Manali", "Lahaul", "Luhri", "Mandi", "Palampur", "Nagrota", "Nahan", "Nadaun", "Nirmand", "Parwanoo", "Pangna", "Padhar", "Rampur", "Rohru", "Renukoot", "Shimla", "Solan", "Sundernagar", "Sirmaur", "Sarahan", "Theog", "Tandi", "Tashigang", "Una", "Udaipur", "Wangtoo"]
        },
        {
            state: "Jharkhand",
            cities: ["Adityapur", "Aurangabad", "Amrapali", "Bokaro Steel City", "Bokaro", "Bagodar", "Bermo", "Baliapur", "Barhi", "Bundu", "Bahragora", "Chaibasa", "Chas", "Chandrapura", "Dhanbad", "Deoghar", "Daltonganj", "Dumka", "Dharampur", "Giridih", "Gumia", "Ghatshila", "Hazaribagh", "Jamshedpur", "Jamtara", "Jharia", "Koderma", "Kendrapara", "Kuchai", "Medininagar", "Madhupur", "Muri", "Malkera", "Nawadih", "Nagar", "Nala", "Patamda", "Palamu", "Pakur", "Pipla", "Ranchi", "Ramgarh", "Raghubar Nagar", "Ranishwar", "Singhbhum", "Seraikela", "Silli", "Sahibganj", "Tundi", "Tata Nagar", "Uchhama", "Vikramshila"]
        },
        {
            state: "Karnataka",
            cities: ["Alnavar", "Ambur", "Anekal", "Arsikere", "Bangalore", "Bagalkot", "Ballari", "Bantwal", "Basavanagudi", "Bidar", "Bijapur", "Bangalore Rural", "Bangalore Urban", "Bhatkal", "Bhadravati", "Channarayapatna", "Chikkamagalur", "Chitradurga", "Chikkaballapur", "Davanagere", "Devanahalli", "Dharwad", "Dandeli", "Gadag", "Gokak", "Gulbarga", "HubliDharwad", "Hassan", "Haveri", "Hospet", "Jog Falls", "Jayanagar", "Jnanabharathi", "Kolar", "Koppal", "Kundapur", "Karwar", "Kodagu", "Kolar Gold Fields", "Kakkanad", "Lakshmeshwar", "Mysore", "Mangalore", "Mandya", "Madhugiri", "Nanjangud", "Navalgund", "Puttur", "Raichur", "Ramanagara", "Ranebennur", "Shimoga", "Sira", "Sirsi", "Sakleshpur", "Tumkur", "Tiptur", "Udupi", "Ujire", "Vijayapura", "Vijayanagara", "Wadi"]
        },
        {
            state: "Kerala",
            cities: ["Alappuzha", "Angamaly", "Adoor", "Attingal", "Bharananganam", "Bharathapuzha", "Changanassery", "Cherthala", "Chirayinkeezhu", "Delhi", "Devikulam", "Ernakulam", "Ettumanoor", "Guruvayur", "Kollam", "Haripad", "Idukki", "Jnanpith", "Kochi", "Kottayam", "Kasaragod", "Kannur", "Kalpetta", "Kumarakom", "Kothamangalam", "Lakkidi", "Munnar", "Malappuram", "Muvattupuzha", "Mundakkayam", "Manjeri", "Nellikkunnu", "Nedumbassery", "Nattika", "Palakkad", "Ponnani", "Pattambi", "Punalur", "Perinthalmanna", "Qurankutty", "Ranni", "Ramankari", "Sreekandapuram", "Shoranur", "Sabarimala", "Thrissur", "Thiruvananthapuram", "Thodupuzha", "Uzhavoor", "Vatakara", "Vypin Island", "Wayanad"]
        },
        {
            state: "Madhya Pradesh",
            cities: ["Alirajpur", "Ashoknagar", "Anuppur", "Agar Malwa", "Bhopal", "Burhanpur", "Balaghat", "Banda", "Biaora", "Chhindwara", "Chhatarpur", "Chachoda", "Dewas", "Dhar", "Damoh", "Dindori", "Guna", "Gwalior", "Hoshangabad", "Harda", "Jabalpur", "Jhabua", "Jorhat", "Khandwa", "Katni", "Kota", "Khurai", "Lahar", "Lalitpur", "Mandsaur", "Mandla", "Morena", "Mhow", "Neemuch", "Narsinghpur", "Niwari", "Pachmarhi", "Panna", "Pithampur", "Raisen", "Raghogarh", "Ratlam", "Rajgarh", "Rewa", "Sagar", "Sihora", "Shivpuri", "Satna", "Tikamgarh", "Tori", "Ujjain", "Umaria", "Vidisha", "Waidhan"]
        },
        {
            state: "Maharashtra",
            cities: ["Aurangabad", "Amravati", "Ahmednagar", "Alibaug", "Akola", "Bhiwandi", "Bhivpur", "Bhadravati", "Chandrapur", "Chinchwad", "Colaba", "Dadar", "Dombivli", "Durg", "Dhule", "Erandol", "Ellora", "Goa", "Gadchiroli", "Gondia", "Goregaon", "Hingoli", "Hamrapur", "Ichalkaranji", "Igatpuri", "Jalgaon", "Jalna", "Junnar", "Junagadh", "Kolhapur", "Kalyan", "Kasarvadavali", "Kandivali", "Kopargaon", "Karad", "Latur", "Lonavala", "Nagpur", "Nanded", "Nashik", "Malegaon", "Mira-Bhayandar", "Matheran", "Mumbai", "Navi Mumbai", "Nandurbar", "Pune", "Panvel", "Pimpri-Chinchwad", "Pali", "Ratnagiri", "Raigad", "Raver", "Solapur", "Satara", "Sangli", "Shirdi", "Shivaji Nagar", "Thane", "Turbhe", "Tuljapur", "Ulhasnagar", "Udgir", "Vasai", "Vikhroli", "Vasai-Virar", "Wadi"]
        },
        {
            state: "Manipur",
            cities: ["Andro", "Airfield", "Bishnupur", "Bungmual", "Churachandpur", "Chandel", "Dimapur", "Dholak", "Hangkhal", "Hmar", "Imphal", "Irang", "Kakching", "Kangpokpi", "Kumbi", "Lamlai", "Langthabal", "Moreh", "Moirang", "Mao", "Matsang", "Ningthoukhong", "Nambol", "Oinam", "Ongnyei", "Porompat", "Patsoi", "Senapati", "Sugnu", "Sadar Hills", "Thoubal", "Tengnoupal", "Ukhrul", "Wangoi"]
        },
        {
            state: "Meghalaya",
            cities: ["Adokgre", "Ampati", "Shillong", "Baghmara", "Bara Basti", "Bodoland", "Cherapunji", "Chedema", "Dawki", "Dalu", "Damra", "Guwahati", "Garo Hills", "Jowai", "Jengjal", "Jaintia Hills", "Khliehriat", "Khanduli", "Mairang", "Mawlai", "Mawlynnong", "Mawngap", "Nongstoin", "Nongpoh", "Pynursla", "Polo", "Sohra", "Smit", "Tura", "Umroi", "Williamnagar", "Wahkhen"]
        },
        {
            state: "Mizoram",
            cities: ["Aizawl", "Adaklu", "Bualpui", "Biate", "Champhai", "Chhura", "Darlawn", "Dawn", "Hnahthial", "Hmar", "Hualngohm", "Ikos", "Iluang", "Kolasib", "Khawzawl", "Kawnpui", "Lunglei", "Lawngtlai", "Mamit", "Mualkawi", "Mizoram University", "Ngopa", "N. H. 54", "Pukpui", "Phuaibuang", "Siaha", "Serchhip", "Saitual", "Tlabung", "Tawi", "Ukhawthar", "Vairengte", "Vengthlang"]
        },
        {
            state: "Nagaland",
            cities: ["Atoizu", "Aghunato", "Bokajan", "Bhandari", "Chümoukedima", "Changtongya", "Dimapur", "Doyang", "Dzükou", "Kohima", "Kiphire", "Kezou", "Mokokchung", "Mon", "Noklak", "Nagaland University", "Phek", "Peren", "Pughoboto", "Wokha", "Zunheboto"]
        },
        {
            state: "Odisha",
            cities: ["Angul", "Aska", "Athgarh", "Astaranga", "Bhubaneswar", "Balasore", "Berhampur", "Bargarh", "Baripada", "Balangir", "Cuttack", "Chandbali", "Chhatrapur", "Dhenkanal", "Debagarh", "Digapahandi", "Daspalla", "Ganjam", "Gopalpur", "Gunupur", "Jajpur", "Jeypore", "Jharsuguda", "Jagatsinghpur", "Khurda", "Kendrapara", "Koraput", "Kalahandi", "Kendujhar", "Mayurbhanj", "Malkangiri", "Manoharpur", "Nayagarh", "Nabarangpur", "Paradip", "Puri", "Phulbani", "Pallahara", "Rayagada", "Rourkela", "Rairangpur", "Sambalpur", "Sundargarh", "Sonepur", "Salepur", "Titlagarh", "Taptapani", "Umerkote", "Utkela", "Vijayawada"]
        },
        {
            state: "Punjab",
            cities: ["Amritsar", "Abohar", "Attari", "Ajnala", "Bathinda", "Barnala", "Banga", "Batala", "Chandigarh", "Dasuya", "Dhuri", "Dera Baba Nanak", "Ferozepur", "Faridkot", "Fatehgarh Sahib", "Gurdaspur", "Ganganagar", "Hoshiarpur", "Haldwani", "Jalandhar", "Jagraon", "Jaitu", "Kapurthala", "Kharar", "Kotkapura", "Ludhiana", "Moga", "Mansa", "Malerkotla", "Mohali", "Nawanshahr", "Nabha", "Patiala", "Phagwara", "Patti", "Rupnagar", "Sangrur", "Sultanpur Lodhi", "Sahibzada Ajit Singh Nagar", "Tarn Taran", "Talwandi Sabo", "Zira"]
        },
        {
            state: "Rajasthan",
            cities: ["Ajmer", "Alwar", "Abu Road", "Anta", "Bikaner", "Bhilwara", "Bundi", "Barmer", "Banswara", "Bharatpur", "Churu", "Dausa", "Dungarpur", "Deeg", "Dholpur", "Jaipur", "Jaisalmer", "Jodhpur", "Jhalawar", "Ganganagar", "Kota", "Kishangarh", "Karauli", "Luni", "Ladnun", "Mount Abu", "Makrana", "Merta City", "Nagaur", "Nimbahera", "Pali", "Phalodi", "Ranthambore", "Rajasthan University", "Sikar", "Sawai Madhopur", "Sirohi", "Shekhawati", "Tonk", "Tarnau", "Udaipur", "Udaipurwati", "Zarapur"]
        },
        {
            state: "Sikkim",
            cities: ["Aritar", "Aho", "Bagdogra", "Bokar", "Chamling", "Chungthang", "Gangtok", "Dzuluk", "Gyalshing", "Kabi Lungchok", "Lachen", "Lachung", "Lingtam", "Mangan", "Martam", "Nayabazar", "Nathang", "Pemayangtse", "Pelling", "Rongli", "Rangpo", "Singtam", "Soreng", "Sichey", "Tathangchen", "Tashiding", "Upper Tadong", "West Sikkim"]
        },
        {
            state: "Tamil Nadu",
            cities: ["Ariyalur", "Ambur", "Alangudi", "Arakkonam", "Bhavani", "Bodinayakanur", "Chennai", "Coimbatore", "Cuddalore", "Chengalpattu", "Dindigul", "Dharmapuri", "Devanampatti", "Erode", "Elanthoor", "Kanchipuram", "Gudiyattam", "Hosur", "Indian Institute of Technology (IIT), Madras", "Ilagai", "Jagir", "Jolarpettai", "Kumbakonam", "Karaikudi", "Kanyakumari", "Kodaikanal", "Krishnagiri", "Lalgudi", "Madurai", "Mettur", "Mayiladuthurai", "Manapparai", "Nagercoil", "Namakkal", "Natham", "Nagapattinam", "Ooty", "Omalur", "Pudukkottai", "Palladam", "Pollachi", "Perambalur", "Ramanathapuram", "Rathinapuri", "Salem", "Sivakasi", "Sriperumbudur", "Sankari", "Tiruchirappalli", "Tirunelveli", "Tirupur", "Tiruvannamalai", "Thanjavur", "Udumalpet", "Uthangarai", "Vellore", "Villupuram", "Wellington"]
        },
        {
            state: "Telangana",
            cities: ["Adilabad", "Armoor", "Asifabad", "Ameenpur", "Bhadradri Kothagudem", "Bodhan", "Bhongir", "Chevella", "Dharmapuri", "Devarkadra", "Doulapur", "Hyderabad", "Gadwal", "Gajwel", "Hanumakonda", "Huzurabad", "Husnabad", "Jagtial", "Jangaon", "Jammikunta", "Karimnagar", "Khammam", "Kothagudem", "Kodad", "Kagaznagar", "Laxmidevipalli", "Medak", "Mahbubnagar", "Mancherial", "Miryalaguda", "Nalgonda", "Nizamabad", "Nagarkurnool", "Peddapalli", "Pochampally", "Ranga Reddy", "Rajanna Sircilla", "Ramagundam", "Suryapet", "Siddipet", "Shadnagar", "Tandur", "Telangana University", "Tirumalapur", "Uppal", "Utnur", "Vikarabad", "Vanaparthi", "Warangal", "Waddepalli", "Yadadri"]
        },
        {
            state: "Tripura",
            cities: ["Agartala", "Ambassa", "Bishalgarh", "Belonia", "Bagafa", "Kailashahar", "Chandrapur", "Churaibari", "Dharmanagar", "Dhalai", "Durgachowmuhani", "Hailakandi", "Khowai", "Lala", "Mohanpur", "Melaghar", "North Tripura", "Pecharthal", "Pratapgarh", "Rangamati", "Rudrasagar", "Sabroom", "Sonamura", "Sasthaban", "Teliamura", "Udaipur"]
        },
        {
            state: "Uttar Pradesh",
            cities: ["Agra", "Aligarh", "Allahabad", "Amroha", "Azamgarh", "Bareilly", "Basti", "Bulandshahr", "Banda", "Bahraich", "Ballia", "Chitrakoot", "Kanpur", "Deoria", "Dhampur", "Dadri", "Farrukhabad", "Faizabad", "Fatehpur", "Ghaziabad", "Gorakhpur", "Greater Noida", "Gautam Buddha Nagar", "Gonda", "Hardoi", "Hapur", "Jhansi", "Jalaun", "Jaunpur", "Jannipur", "Kushinagar", "Kanauj", "Kasganj", "Lucknow", "Lalitpur", "Meerut", "Mathura", "Muzaffarnagar", "Mainpuri", "Moradabad", "Noida", "Nagina", "Nawabganj", "Orai", "Onra", "Prayagraj", "Pilibhit", "Raebareli", "Rampur", "Rae Bareli", "Saharanpur", "Sambhal", "Sitapur", "Shahjahanpur", "Sultanpur", "Tundla", "Tajganj", "Unnao", "Varanasi", "Vikramshila", "Yamuna Nagar"]
        },
        {
            state: "Uttarakhand",
            cities: ["Almora", "Auli", "Augustmuni", "Bageshwar", "Bhowali", "Badrinath", "Chakrata", "Champawat", "Dehradun", "Dharampur", "Dhanolti", "Haridwar", "Haldwani", "Jaspur", "Joshimath", "Jwalapur", "Kashipur", "Karanprayag", "Kedarnath", "Lansdowne", "Lalkuan", "Mussoorie", "Muni Ki Reti", "Mahatma Gandhi Chauraha", "Nainital", "Narendra Nagar", "Naugaon", "Pithoragarh", "Rishikesh", "Pantnagar", "Rudrapur", "Roorkee", "Srinagar", "Sahastradhara", "Siddharthnagar", "Tehri", "Tihri", "Uttarkashi", "Udham Singh Nagar", "Vikasnagar"]
        },
        {
            state: "West Bengal",
            cities: ["Asansol", "Alipurduar", "Arambagh", "Alambazar", "Burdwan", "Bankura", "Birbhum", "Bongaon", "Bally", "Baranagar", "Kolkata", "Chandannagar", "Cooch Behar", "Durgapur", "Darjeeling", "Diamond Harbour", "Dinhata", "Egra", "Enayetnagar", "Farakka", "Fulbari", "Garia", "Howrah", "Haldia", "Hooghly", "Habra", "Ichchhpur", "Islampur", "Jalpaiguri", "Jadavpur", "Jalalpur", "Kurseong", "Kalyani", "Kharagpur", "Lakshmikantapur", "Lalbagh", "Malda", "Midnapore", "Murarai", "Maldah", "Nadia", "Nabagram", "Naihati", "Purulia", "Panshkura", "Panihati", "Ranishwar", "Raiganj", "Raghunathganj", "Siliguri", "Santiniketan", "Suri", "Serampore", "Tamluk", "Tarakeswar", "Tehatta", "Uttarpara", "Uluberia"]
        }
    ];

    // Scroll to top on mount
    useEffect(() => { window.scrollTo(0, 0); }, []);

    // Restore coupon from localStorage on mount
    useEffect(() => {
        const saved = localStorage.getItem('cartCoupon');
        if (saved) {
            try { setCouponData(JSON.parse(saved)); } catch { localStorage.removeItem('cartCoupon'); }
        }
    }, []);

    useEffect(() => {
        if(userdata && userdata?.address){
            setAddress({
                // city: userdata.address.city,
                // state: userdata.address.state,
                country: "India",
                address: userdata.address.address,
                state: userdata.address.state,
                city: userdata.address.city,
                pincode: userdata.address.pincode,
            });
            setName(userdata.name);
            setEmail(userdata.email);
            setSelectedCity(userdata.address.city);
            setSelectedState(userdata.address.state);
        }
    }, [userdata]);

    useEffect(() => {
        setAddress(x => ({...x, state: selectedState, city: selectedCity}))
    }, [selectedState, selectedCity]);

    const cartTotal = userdata?.cart?.reduce((sum, pro) => sum + (pro.price * pro.quantity), 0) || 0;
    const discount = couponData?.discountAmount || 0;
    const finalTotal = cartTotal - discount;

    const applyCoupon = () => {
        if (!couponInput.trim()) return;
        setCouponLoading(true);
        setCouponError('');
        setCouponData(null);
        fetch('https://pentadeco.in/api/validatecoupon', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: couponInput.trim(), cartTotal })
        }).then(res => res.json()).then(data => {
            setCouponLoading(false);
            if (data.success) {
                setCouponData(data);
                localStorage.setItem('cartCoupon', JSON.stringify(data));
            } else {
                setCouponError(data.msg);
            }
        }).catch(() => {
            setCouponLoading(false);
            setCouponError('Failed to apply coupon');
        });
    };

    const removeCoupon = () => {
        setCouponData(null);
        setCouponInput('');
        setCouponError('');
        localStorage.removeItem('cartCoupon');
    };

    const edituserfunc = () => {
        const finaladdress = {...address, city: selectedCity, state: selectedState};
        fetch(`https://pentadeco.in/api/edituser/${userdata._id}`, {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({address: finaladdress, name: name, email: email})
        }).then(res => res.json()).then(data => {
            if(data.success){
                login(data.user);
            }
        })
    }

    const orderFunc = () => {
        if(
            userdata.address.city &&
            userdata.address.state &&
            userdata.address.address && 
            userdata.address.country && 
            userdata.address.pincode &&
            userdata.name
        ){
            fetch(`https://pentadeco.in/api/order/${userdata._id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({address: {...address, name: userdata.name}, couponCode: couponData?.code || null})
            }).then(res => res.json()).then(data => {
                if(data.success){
                    localStorage.removeItem('cartCoupon');
                    navigate('/order-success', { state: { order: data.order } });
                }
            })
        }
    }

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const payonlineFunc = () => {
        if (
            userdata.address.city &&
            userdata.address.state &&
            userdata.address.address &&
            userdata.address.country &&
            userdata.address.pincode &&
            userdata.name
        ) {
            fetch(`https://pentadeco.in/api/initializepayment/${userdata._id}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ address: { ...address, name: userdata.name }, couponCode: couponData?.code || null }),
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        const confirmedCouponCode = data.couponCode || null;
                        const options = {
                            key: data.key,
                            amount: data.amount,
                            currency: data.currency,
                            order_id: data.razorpayOrderId,
                            name: "Pentadeco",
                            description: "Payment",
                            handler: function (response) {
                                // Step 2: Verify payment
                                fetch("https://pentadeco.in/api/verifypayment", {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({
                                        userid: userdata._id,
                                        razorpay_order_id: response.razorpay_order_id,
                                        razorpay_payment_id: response.razorpay_payment_id,
                                        razorpay_signature: response.razorpay_signature,
                                        address: { ...address, name: userdata.name },
                                        couponCode: confirmedCouponCode,
                                    }),
                                }).then(res => res.json()).then(verdata => {
                                    if(verdata.success){
                                        localStorage.removeItem('cartCoupon');
                                        navigate('/order-success', { state: { order: verdata.order } });
                                    };
                                });
                            },
                        };
                        const rzp = new window.Razorpay(options);
                        rzp.open();
                    }
                });
        }
    }

    return (
        <div className='main-cart'>
            <div className="container my-5">

                {/* Page header */}
                <div className="d-flex align-items-baseline gap-2 mb-4">
                    <h2 className="fs-2 body-font-bold mb-0">Cart</h2>
                    {userdata?.cart?.length > 0 && (
                        <span className="text-muted body-font-medium fs-sm">({userdata.cart.length} {userdata.cart.length === 1 ? 'item' : 'items'})</span>
                    )}
                </div>

                {userdata?.cart?.length > 0 ? (
                    <div className="row align-items-start p-0 m-0">

                        {/* Left — cart items */}
                        <div className="col-md-8 p-0 pe-md-3">
                            {userdata.cart.map((pro, ind) => (
                                <div key={ind} className="mb-3">
                                    <Tablecard name={pro.proname} id={pro.id} disprice={pro.price} img={pro.img} quantity={pro.quantity} ind={0} />
                                </div>
                            ))}
                        </div>

                        {/* Right — summary + form */}
                        <div className="col-md-4 p-0">

                            {/* Price summary card */}
                            <div className="cart-sidebar-card rounded-brand border overflow-hidden mb-3 bg-white">
                                <div className="cart-sidebar-header px-3 py-2 border-bottom">
                                    <p className="mb-0 body-font-bold">Price Summary</p>
                                </div>
                                <div className="p-3">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className="text-muted fs-sm">Total MRP</span>
                                        <span className="body-font-medium fs-sm">₹{cartTotal}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <span className="text-success fs-sm">
                                            <i className="fi fi-ss-check-circle me-1" style={{position: 'relative', bottom: '-1px'}}></i>
                                            Free Delivery
                                        </span>
                                        <span className="text-success fs-sm body-font-semibold">FREE</span>
                                    </div>

                                    {/* Coupon */}
                                    <div className="mb-3">
                                        {couponData ? (
                                            <div className="d-flex align-items-center justify-content-between bg-success bg-opacity-10 border border-success rounded-brand-sm px-2 py-2">
                                                <p className="mb-0 text-success body-font-semibold fs-sm">
                                                    <i className="fi fi-ss-check-circle me-1" style={{position: 'relative', bottom: '-1px'}}></i>
                                                    {couponData.code} applied
                                                </p>
                                                <span className="text-danger cursor-pointer fs-sm body-font-bold" onClick={removeCoupon}>Remove</span>
                                            </div>
                                        ) : (
                                            <div className="d-flex gap-2">
                                                <input
                                                    type="text"
                                                    className="form-control shadow-none outline-none border rounded-brand-sm fs-sm"
                                                    placeholder="Coupon code"
                                                    value={couponInput}
                                                    onChange={e => { setCouponInput(e.target.value); setCouponError(''); }}
                                                    onKeyDown={e => e.key === 'Enter' && applyCoupon()}
                                                />
                                                <button
                                                    className="btn btn-brand-secondary text-nowrap fs-sm px-3 rounded-brand-sm"
                                                    onClick={applyCoupon}
                                                    disabled={couponLoading}
                                                >
                                                    {couponLoading ? '...' : 'Apply'}
                                                </button>
                                            </div>
                                        )}
                                        {couponError && <p className="mb-0 text-danger fs-sm mt-1">{couponError}</p>}
                                    </div>

                                    {discount > 0 && (
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="text-success fs-sm body-font-medium">Coupon Discount</span>
                                            <span className="text-success fs-sm body-font-semibold">-₹{discount}</span>
                                        </div>
                                    )}

                                    <div className="d-flex justify-content-between pt-2 border-top mt-1">
                                        <span className="body-font-bold fs-5">Total</span>
                                        <span className="body-font-bold fs-5 text-brand-secondary">₹{finalTotal}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Delivery details card */}
                            <div className="cart-sidebar-card rounded-brand border overflow-hidden mb-3 bg-white">
                                <div className="cart-sidebar-header px-3 py-2 border-bottom">
                                    <p className="mb-0 body-font-bold">Delivery Details</p>
                                </div>
                                <div className="p-3">
                                    <div className="cart-field-group mb-2">
                                        <label className="cart-field-label">Full Name</label>
                                        <input type="text" className='form-control shadow-none outline-none border rounded-brand-sm' placeholder='Your name' onChange={(e) => {setName(e.target.value); setIsDirty(true)}} value={name} />
                                    </div>
                                    <div className="cart-field-group mb-2">
                                        <label className="cart-field-label">Mobile Number</label>
                                        <input type="number" className='form-control shadow-none outline-none border rounded-brand-sm' placeholder='Mobile Number' value={userdata.number} disabled />
                                    </div>
                                    <div className="cart-field-group mb-2">
                                        <label className="cart-field-label">Email Address</label>
                                        <input type="email" className='form-control shadow-none outline-none border rounded-brand-sm' placeholder='Email address' onChange={(e) => {setEmail(e.target.value); setIsDirty(true)}} value={email} />
                                    </div>
                                    <div className="d-flex gap-2 mb-2">
                                        <div className="cart-field-group w-50">
                                            <label className="cart-field-label">State</label>
                                            <select
                                                className='form-control shadow-none outline-none border rounded-brand-sm'
                                                value={selectedState}
                                                onChange={(e) => {
                                                    setSelectedState(e.target.value);
                                                    setSelectedCity("");
                                                    setIsDirty(true);
                                                }}
                                            >
                                                <option value="">Select State</option>
                                                {allcities.map((item) => (
                                                    <option key={item.state} value={item.state}>{item.state}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="cart-field-group w-50">
                                            <label className="cart-field-label">City</label>
                                            <select
                                                className='form-control shadow-none outline-none border rounded-brand-sm'
                                                value={selectedCity}
                                                onChange={(e) => { setSelectedCity(e.target.value); setIsDirty(true); }}
                                                disabled={!selectedState}
                                            >
                                                <option value="">Select City</option>
                                                {selectedState &&
                                                    allcities.find((item) => item.state === selectedState)?.cities.map((city) => (
                                                        <option key={city} value={city}>{city}</option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="cart-field-group mb-2">
                                        <label className="cart-field-label">Street Address</label>
                                        <textarea className='form-control shadow-none outline-none border rounded-brand-sm' placeholder='House no., Street, Area...' onChange={(e) => {setAddress(x => ({...x, address: e.target.value})); setIsDirty(true)}} value={address?.address} rows={2}></textarea>
                                    </div>
                                    <div className="cart-field-group mb-3">
                                        <label className="cart-field-label">Pincode</label>
                                        <input type="number" className='form-control shadow-none outline-none border rounded-brand-sm' placeholder='e.g. 400097' onChange={(e) => {setAddress(x => ({...x, pincode: e.target.value})); setIsDirty(true)}} value={address?.pincode} />
                                    </div>

                                    {(isDirty || !userdata?.address?.address) && (
                                        <button
                                            className="btn btn-brand-secondary w-100 rounded-brand-sm py-2"
                                            onClick={() => { edituserfunc(); setIsDirty(false); }}
                                        >
                                            Save Details
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* Checkout button — desktop sticky */}
                            {!(isDirty || !userdata?.address?.address) && (
                                <div className="desk-fix-checkout">
                                    <button className="btn btn-brand-secondary w-100 py-3 rounded-brand-sm letter-spacing body-font-semibold" onClick={() => setOptionpop('flex')}>
                                        PROCEED TO CHECKOUT
                                    </button>
                                </div>
                            )}

                        </div>
                    </div>
                ) : (
                    <div className="cart-empty-state text-center py-5">
                        <p className="text-muted mb-1" style={{fontSize: '56px', lineHeight: 1}}>
                            <i className="fi fi-rr-shopping-cart"></i>
                        </p>
                        <h4 className="body-font-bold mt-3 mb-2">Your cart is empty</h4>
                        <p className="text-muted fs-sm mb-4">Looks like you haven't added anything yet.</p>
                        <Link to="/product" className="btn btn-brand-secondary px-5 py-2 rounded-brand-sm">Shop Now</Link>
                    </div>
                )}
            </div>

            <div className="hover-checkout-wrap">
                {userdata?.cart?.length > 0 && (
                    (isDirty || !userdata?.address?.address) ? (
                        <div className="cart-mobile-bar cart-mobile-bar--disabled">
                            <p className="mb-0 fs-sm body-font-medium">Fill details to proceed</p>
                        </div>
                    ) : (
                        <div className="cart-mobile-bar" onClick={() => setOptionpop('flex')}>
                            <p className="mb-0 body-font-bold letter-spacing">CHECKOUT</p>
                            <p className="mb-0 body-font-bold">₹{finalTotal}</p>
                        </div>
                    )
                )}
            </div>

            <div className="popup-wrap" style={{display: optionpop}} onClick={(e) => { if(e.target === e.currentTarget) setOptionpop("none"); }}>
                <div className="popup bg-white">

                    {/* Drag handle */}
                    <div className="d-flex justify-content-center pt-3 pb-1">
                        <div className="checkout-popup-handle"></div>
                    </div>

                    {/* Header */}
                    <div className="d-flex align-items-center justify-content-between px-4 py-2 border-bottom">
                        <p className="mb-0 body-font-bold fs-5">Checkout</p>
                        <div className="checkout-close-btn cursor-pointer" onClick={() => setOptionpop("none")}>
                            <i className="fi fi-ss-cross" style={{fontSize: '11px', position: 'relative', bottom: '-1px'}}></i>
                        </div>
                    </div>

                    {/* Order summary */}
                    <div className="px-4 py-3" style={{background: 'var(--light)'}}>
                        <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted fs-sm">Cart Total</span>
                            <span className="fs-sm body-font-medium">₹{cartTotal}</span>
                        </div>
                        {discount > 0 && (
                            <div className="d-flex justify-content-between mb-2">
                                <span className="text-success fs-sm">
                                    <i className="fi fi-ss-check-circle me-1" style={{position: 'relative', bottom: '-1px'}}></i>
                                    {couponData.code}
                                </span>
                                <span className="text-success fs-sm body-font-medium">-₹{discount}</span>
                            </div>
                        )}
                        <div className="d-flex justify-content-between align-items-center pt-2 border-top mt-1">
                            <span className="body-font-bold">To Pay</span>
                            <span className="body-font-bold fs-4 text-brand-secondary">₹{finalTotal}</span>
                        </div>
                    </div>

                    {/* Payment options */}
                    <div className="px-4 pt-3 pb-5">
                        <p className="text-muted fs-sm mb-3 body-font-medium">Choose payment method</p>

                        <div className="checkout-pay-option mb-3" onClick={payonlineFunc}>
                            <div className="checkout-pay-icon">
                                <i className="fi fi-ss-credit-card" style={{position: 'relative', bottom: '-2px'}}></i>
                            </div>
                            <div className="flex-grow-1">
                                <p className="mb-0 body-font-bold lh-1">Pay Online</p>
                                <p className="mb-0 text-muted fs-sm mt-1">UPI · Cards · Net Banking</p>
                            </div>
                            <i className="fi fi-rr-angle-right text-muted" style={{position: 'relative', bottom: '-2px'}}></i>
                        </div>

                        <div className="checkout-pay-option checkout-pay-option--filled" onClick={orderFunc}>
                            <div className="checkout-pay-icon checkout-pay-icon--filled">
                                <i className="fi fi-ss-truck-side" style={{position: 'relative', bottom: '-2px'}}></i>
                            </div>
                            <div className="flex-grow-1">
                                <p className="mb-0 body-font-bold lh-1">Cash on Delivery</p>
                                <p className="mb-0 text-muted fs-sm mt-1">Pay when you receive</p>
                            </div>
                            <i className="fi fi-rr-angle-right text-muted" style={{position: 'relative', bottom: '-2px'}}></i>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default Cart;